export default "__VITE_ASSET__BNvsy3xV__"